import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { exhaustMap, map, take } from 'rxjs/operators';
import { ScheduleService } from '../../service/schedule.service';

import * as tasksActions from './tasks.actions';

@Injectable()
export class TasksEffects {

    constructor(private actions$: Actions, private scheduleService: ScheduleService) {
    }

    list$ = createEffect(() =>
        this.actions$.pipe(
            ofType(tasksActions.taskList),
            exhaustMap(() =>
                this.scheduleService.getTasks().pipe(
                    map(response => tasksActions.tasksListSuccess({tasks: response}))
                )
            )));

    addTaskSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(tasksActions.setTaskSuccess),
            exhaustMap(action =>
                new Observable<any>(observable => observable.next(true)).pipe(
                    take(1),
                    map(() => tasksActions.setTask({editTask: action.editTask}))
                )
            )
        )
    );
}
